import { useEffect, useState } from 'react';

// Pide un reporte para el periodo actual y el anterior (para los "+12% vs …").
export function useReporte<T>(pedir: (ini: string, fin: string) => Promise<{ data: T }>, actual: [string, string], previo: [string, string]) {
  const [datos, setDatos] = useState<{ actual: T; previo: T | null } | null>(null);
  const [error, setError] = useState('');
  const clave = actual.join() + previo.join();

  useEffect(() => {
    let vivo = true;
    setError('');
    Promise.all([pedir(...actual), pedir(...previo).catch(() => null)])
      .then(([a, p]) => vivo && setDatos({ actual: a.data, previo: p?.data ?? null }))
      .catch((e: any) => vivo && setError(e.response?.data?.error || 'No se pudo cargar el reporte.'));
    return () => { vivo = false; };
  }, [clave]); // eslint-disable-line react-hooks/exhaustive-deps

  return { datos, error };
}

export const num = (v: any) => parseFloat(v || 0) || 0;
